// src/store/index.js


const state = {
    currentRestaurant: null,
    restaurants: [
        { id: 1, name: "Restaurant Centre", location: "Centre-ville" },
        { id: 2, name: "Restaurant Nord", location: "Quartier Nord" }
    ],
    servers: [
        { id: 1, name: "Alice", restaurant_id: 1 },
        { id: 2, name: "Bob", restaurant_id: 2 }
    ],
    cashRegisters: [
        { id: 1, restaurant_id: 1, status: "closed" },
        { id: 2, restaurant_id: 2, status: "open" }
    ],
    bars: [
        { id: 1, restaurant_id: 1, entrepot_id: 11 },
        { id: 2, restaurant_id: 2, entrepot_id: 22 }
    ],
    kitchens: [
        { id: 1, restaurant_id: 1, entrepot_id: 33 },
        { id: 2, restaurant_id: 2, entrepot_id: 44 }
    ],
    products: [
        { id: 1, name: "Café", type: "bar", price: 2.5, stock: 100 },
        { id: 2, name: "Bière", type: "bar", price: 5, stock: 50 },
        { id: 3, name: "Vin", type: "bar", price: 7, stock: 30 },
        { id: 4, name: "Pizza", type: "cuisine", price: 12, stock: 20 },
        { id: 5, name: "Pâtes", type: "cuisine", price: 10, stock: 15 },
        { id: 6, name: "Salade", type: "cuisine", price: 8, stock: 25 }
    ],
    tables: [
        { id: 1, number: 1, restaurant_id: 1, status: "free" },
        { id: 2, number: 2, restaurant_id: 1, status: "occupied" },
        { id: 3, number: 3, restaurant_id: 1, status: "free" },
        { id: 4, number: 1, restaurant_id: 2, status: "free" },
        { id: 5, number: 2, restaurant_id: 2, status: "occupied" }
    ],
    orders: [],
    notifications: [],
    currentServer: null
};

const mutations = {
    SET_CURRENT_RESTAURANT(state, restaurant) {
        state.currentRestaurant = restaurant;
    },
    SET_CURRENT_SERVER(state, server) {
        state.currentServer = server;
    },
    ADD_ORDER(state, order) {
        state.orders.push(order);
    },
    UPDATE_ORDER_STATUS(state, { orderId, itemId, status, station }) {
        const order = state.orders.find(o => o.id === orderId);
        if (order) {
            const item = order.items.find(i => i.id === itemId);
            if (item) {
                item.status = status;
                item.updatedAt = new Date();

                // Notification
                state.notifications.push({
                    id: Date.now(),
                    type: 'status_update',
                    message: `${item.name} est ${status} (${station})`,
                    orderId,
                    timestamp: new Date()
                });
            }
        }
    },
    UPDATE_CASH_REGISTER_STATUS(state, { registerId, status }) {
        const register = state.cashRegisters.find(cr => cr.id === registerId);
        if (register) {
            register.status = status;
        }
    },
    ADD_NOTIFICATION(state, notification) {
        state.notifications.push({
            id: Date.now(),
            ...notification,
            timestamp: new Date()
        });
    },
    MARK_NOTIFICATION_READ(state, notificationId) {
        const notification = state.notifications.find(n => n.id === notificationId);
        if (notification) {
            notification.read = true;
        }
    },
    UPDATE_TABLE_STATUS(state, { tableId, status }) {
        const table = state.tables.find(t => t.id === tableId);
        if (table) {
            table.status = status;
        }
    }
};

const actions = {
    selectRestaurant({ commit }, restaurant) {
        commit('SET_CURRENT_RESTAURANT', restaurant);
    },
    selectServer({ commit }, server) {
        commit('SET_CURRENT_SERVER', server);
    },
    createOrder({ commit, state }, orderData) {
        const cashRegister = state.cashRegisters.find(
            cr => cr.restaurant_id === state.currentRestaurant.id
        );

        if (cashRegister && cashRegister.status !== 'open') {
            throw new Error('La caisse doit être ouverte pour prendre une commande');
        }

        const newOrder = {
            id: Date.now(),
            tableId: orderData.tableId,
            serverId: state.currentServer.id,
            restaurantId: state.currentRestaurant.id,
            items: orderData.items.map(item => ({
                id: Date.now() + Math.random(),
                productId: item.productId,
                name: item.name,
                type: item.type,
                price: item.price,
                quantity: item.quantity,
                status: 'pending',
                createdAt: new Date(),
                updatedAt: new Date()
            })),
            status: 'active',
            total: orderData.items.reduce((sum, item) => sum + (item.price * item.quantity), 0),
            createdAt: new Date(),
            paid: false
        };

        commit('ADD_ORDER', newOrder);
        commit('UPDATE_TABLE_STATUS', { tableId: orderData.tableId, status: 'occupied' });

        // Simuler l'envoi aux stations
        setTimeout(() => {
            newOrder.items.forEach(item => {
                if (item.type === 'bar') {
                    commit('ADD_NOTIFICATION', {
                        type: 'new_order_bar',
                        message: `Nouvelle commande bar: ${item.name}`,
                        orderId: newOrder.id
                    });
                } else if (item.type === 'cuisine') {
                    commit('ADD_NOTIFICATION', {
                        type: 'new_order_kitchen',
                        message: `Nouvelle commande cuisine: ${item.name}`,
                        orderId: newOrder.id
                    });
                }
            });
        }, 1000);

        return newOrder;
    },
    updateItemStatus({ commit }, { orderId, itemId, status, station }) {
        commit('UPDATE_ORDER_STATUS', { orderId, itemId, status, station });
    },
    toggleCashRegister({ commit, state }, registerId) {
        const register = state.cashRegisters.find(cr => cr.id === registerId);
        if (register) {
            const newStatus = register.status === 'open' ? 'closed' : 'open';
            commit('UPDATE_CASH_REGISTER_STATUS', { registerId, status: newStatus });
        }
    },
    markNotificationRead({ commit }, notificationId) {
        commit('MARK_NOTIFICATION_READ', notificationId);
    },
    serveOrder({ commit, state }, orderId) {
        const order = state.orders.find(o => o.id === orderId);
        if (order) {
            order.items.forEach(item => {
                if (item.status === 'ready') {
                    commit('UPDATE_ORDER_STATUS', {
                        orderId,
                        itemId: item.id,
                        status: 'served',
                        station: 'serveur'
                    });
                }
            });

            // Vérifier si tous les items sont servis
            const allServed = order.items.every(item => item.status === 'served');
            if (allServed) {
                order.status = 'completed';
            }
        }
    }





};

const getters = {
    currentRestaurantOrders: state =>
        state.orders.filter(order => order.restaurantId === state.currentRestaurant?.id),
    barOrders: state =>
        state.orders.filter(order =>
            order.restaurantId === state.currentRestaurant?.id &&
            order.items.some(item => item.type === 'bar' && item.status !== 'served')
        ),
    kitchenOrders: state =>
        state.orders.filter(order =>
            order.restaurantId === state.currentRestaurant?.id &&
            order.items.some(item => item.type === 'cuisine' && item.status !== 'served')
        ),
    currentRestaurantTables: state =>
        state.tables.filter(table => table.restaurant_id === state.currentRestaurant?.id),
    unreadNotifications: state =>
        state.notifications.filter(n => !n.read),
    currentCashRegister: state =>
        state.cashRegisters.find(cr => cr.restaurant_id === state.currentRestaurant?.id)
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};